import React, { useEffect, useReducer } from "react";
import { terminReducer } from "app/hostingReducer";

const BillingCycleOptions = ({ termin, terminHandle, productsItem, pid }) => {
  const [terminShow, terminDispatch] = useReducer(terminReducer, {
    monthly: false,
    quarterly: false,
    semiannually: false,
    annually: false,
    biennially: false,
    triennially: false,
  });

  // Buat array label termin
  const periodLabels = {
    monthly: "1 Bulan",
    quarterly: "3 Bulan",
    semiannually: "6 Bulan",
    annually: "1 Tahun",
    biennially: "2 Tahun",
    triennially: "3 Tahun",
  };

  useEffect(() => {
    const periods = [
      "monthly",
      "quarterly",
      "semiannually",
      "annually",
      "biennially",
      "triennially",
    ];
    
    const shouldUpdate = periods.some(period => {
      if (productsItem.price && productsItem.price.hasOwnProperty(period)) {
        const value = productsItem.price[period];
        const isPromo = productsItem.promo && productsItem.promo.promocode !== "FREETRIALWPQW";
        const newState = +value > 0 || (period === "monthly" && isPromo);
        return terminShow[period] !== newState;
      }
      return false;
    });

    if (shouldUpdate) {
      periods.forEach((period) => {
        if (productsItem.price && productsItem.price.hasOwnProperty(period)) {
          const value = productsItem.price[period];
          const isPromo = productsItem.promo && productsItem.promo.promocode !== "FREETRIALWPQW";
          const payload = +value > 0 || (period === "monthly" && isPromo);
          terminDispatch({ type: `ENABLE_${period.toUpperCase()}`, payload });
        }
      });
    }
  }, [productsItem, productsItem.price, productsItem.promo]);

  // Ambil hanya termin yang aktif
  const availablePeriods = Object.keys(terminShow).filter((period) => terminShow[period]);

  return (
    <div className="mt-3">
      <label htmlFor="activePeriod" className="mb-2 fw-bold">
        Durasi
      </label>
      <select
        className="form-select"
        id="activePeriod"
        name="activePeriod"
        value={termin}
        onChange={terminHandle}
        style={{ width: "100%" }}
      >
        {availablePeriods.map((period) => (
          <option value={period} key={period}>
            {periodLabels[period]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BillingCycleOptions;
